var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',_vm._b({},'el-tree',_vm.attr,false))
}
var staticRenderFns = []

export { render, staticRenderFns }